import { Button, Modal, ModalBody } from "reactstrap";
import { ThankYouSpecialIcon } from "../../assets/designedPickedIcons";
import { Link } from "react-router-dom";

const ThankYouModal2 = ({ isOpen, setisOpen, text }) => {
  return (
    <Modal
      fade={false}
      centered
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody
        className="bg-white"
        style={{ borderRadius: "20px", animation: "scale-in 0.3s linear 1" }}
      >
        <div className="text-center">
          <ThankYouSpecialIcon />
          <h4 className="color-primary-blue f-6 m-0">Thank You!</h4>
          <p
            style={{ color: "rgba(33, 33, 33, 1)" }}
            className="text-center f-4 mb-5 mt-3"
          >
            {text}
          </p>
        </div>
        <div className="px-4 mb-3 ">
          <Link
            to={"/places"}
            className="btn f-6 d-block standard-rounded-btn text-white full-width"
          >
            Go to My Places
          </Link>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ThankYouModal2;
